import AddressForm from '../form/address_form';
import loadAdyenDropin from './load_adyen_dropin.js';
import AdditionalOptions from './additional_options.js';

export default function initializeDeliveryAddress() {

    let $deliveryFormAddAccordion = $('#deliveryFormAddAccordion');
    let $deliveryFormEditAccordion = $('#deliveryFormEditAccordion');
    let $manageDelAccordion = $('#manageDelAccordion');

    const $additionalOptions = new AdditionalOptions('.additionalDeliveryOption', () => {
        $manageDelAccordion.collapse('hide');
        loadAdyenDropin();
    });

    // Fix the Add new address form save button
    const $addressFormFields = $('.deliveryAddressForm .form-fields');
    $addressFormFields.removeClass('d-none');
    $addressFormFields.find('button.new-btn').removeClass('small');
    $addressFormFields.find('div:last')
        .removeClass('justify-content-between')
        .addClass('justify-content-end')
        .find('button:last').remove();

    let DeliveryAddressAddForm = new AddressForm({
        form_id: "#deliveryFormAddAccordion .deliveryAddressForm",
        read_url: `/delivery-address/read`,
    });

    $deliveryFormAddAccordion.on('shown.bs.collapse', function (event) {
        $deliveryFormEditAccordion.collapse('hide');
    });

    let DeliveryAddressEditForm = new AddressForm({
        form_id: "#deliveryFormEditAccordion .deliveryAddressForm",
        read_url: `/delivery-address/read`,
    });

    $('input[name="deliveryAddressId"]').on('change', function () {
        $deliveryFormEditAccordion.collapse('hide');
        $deliveryFormAddAccordion.collapse('hide');
    });

    $deliveryFormEditAccordion.on('shown.bs.collapse', function (event) {
        $deliveryFormAddAccordion.collapse('hide');

        let DeliveryAddId = $('input[name="deliveryAddressId"]:checked').val();

        DeliveryAddressEditForm.turnFormLoadingOn();

        DeliveryAddressEditForm.setAction("/delivery-address/update/" + DeliveryAddId);
        DeliveryAddressEditForm.hideDropdown('add_lookuplist');

        DeliveryAddressEditForm.populateFields(DeliveryAddId, (form, data) => {

            const $slAccountSelect = $('select[name="slAccount"]', form);
            const $postCodeInput = $('input[name="postCode"]', form);
            const $countrySelect = $('select[name="country"]', form);

            const selectedAccountNumber = $('#selectedAccountNumber', form).val();
            $slAccountSelect.updateVal(selectedAccountNumber).setDisabled(true);

            const selectedCountry = form.find('.selectedCountry').val();
            $countrySelect.updateVal(selectedCountry);
            $countrySelect.setDisabled(true);
            DeliveryAddressEditForm.turnFormLoadingOff();

            $postCodeInput.prop("disabled", true).addClass("disabled");
        });
    });

    function reloadDeliveryAddress(id = null) {

        $("body").css("cursor", "progress");

        if (!id) {
            id = $('input[name="deliveryAddressId"]:checked').val();
        }

        axios.get(`/my-basket/delivery-address/${id}`).then(deliveryResponse => {

            let address = deliveryResponse.data.selectedAddress;
            $('.default_delivery--options .default-address').html(`
                <li class="addressLine1">${address.addressLine1}</li>
                <li class="addressLine2">${address.addressLine2 ?? ''}</li>
                <li class="city">${address.city}</li>
                <li class="postCode">${address.postCode}</li>
                <li class="countryCode">${address.countryCode}</li>
            `);

            $additionalOptions.showAdditionalOptions(address.countryCode);

            $('.delivery_address--options').replaceWith(deliveryResponse.data.html);
            $deliveryFormAddAccordion.collapse('hide');
            $deliveryFormEditAccordion.collapse('hide');
            $manageDelAccordion.collapse('hide');
            DeliveryAddressEditForm.emptyForm();
            DeliveryAddressAddForm.emptyForm(true);
            DeliveryAddressAddForm.turnFormLoadingOff();
            $('#manageDelAccordion').removeClass('loading');
            loadAdyenDropin();
        }).finally(() => {
            $("body").css("cursor", "default");
        });
    }

    DeliveryAddressAddForm.addSubmitListener((response) => {
        reloadDeliveryAddress(response.data.id);
    });

    DeliveryAddressEditForm.addSubmitListener(() => {
        reloadDeliveryAddress();
    });

    $(document).on('click', '#deliveryAddressBtnContainer .use-selected', function () {
        reloadDeliveryAddress();
    });

    $(document).on('click', '.remove-address-btn', function () {
        let id = $(this).attr("data-address-id");

        $("body").css("cursor", "progress");
        $('#manageDelAccordion').addClass('loading');
        axios
            .delete(`/delivery-address/delete/${id}`)
            .then(function (response) {
                if (id === $('input[name="deliveryAddressId"]:checked').val()) {
                    window.location.reload(); // TODO handle this better
                }
                reloadDeliveryAddress();
            })
            .finally(() => {
                $("body").css("cursor", "default");
            });
    });

}